import { addStyles } from 'ethcss'
import item from 'blocks.simple/item/item.jcss'
import { grid, IStyles } from '../../../theme'
import { defaultThemeTableStyles } from '../../../atoms/Table/Table-theme'

const styles: IStyles = {
    wrapper() {
        return {
            [`& tr:hover .${this.deleteIcon}`]: {
                ...item.visible,
            },
        }
    },
    deleteIcon: {
        ...item.hidden,
    },
    selectAllWrapper: {
        display: 'flex',
        justifyContent: 'center',
        zIndex: 2,
        position: 'relative',
    },
    selectAll: {
        width: 'auto !important',
    },
    sticky: {
        position: 'sticky',
        top: 1,
        backgroundColor: `var(--var-module-ui-component-table-style-background, ${defaultThemeTableStyles['background']})`,
        zIndex: 1,

        '&:before': {
            content: '""',
            position: 'absolute',
            left: -1,
            right: -1,
            bottom: -1,
            top: -1,
            border: `1px solid var(--var-module-ui-component-table-style-cellBorder, ${defaultThemeTableStyles['cellBorder']})`,
            zIndex: 1,
        },
        '&:after': {
            content: '""',
            position: 'absolute',
            left: -1,
            right: -1,
            top: -2,
            height: 2,
            backgroundColor: `var(--var-module-ui-component-table-style-background, ${defaultThemeTableStyles['background']})`,
        },
    },
}

addStyles(styles)
export default styles
